import React from "react";
import omitBy from "lodash/omitBy";
import { Text as NBText, Factory } from "native-base";
import {WithBaseStyles, WithHighlight} from "../hoc";

const textFactory = () => {
    return React.forwardRef((props, ref) => {
        const {
            color = "inherit",
            fontWeight = "inherit",
            whiteSpace = "inherit",
            textDecorationLine = "inherit",
        } = props;

        const componentProps ={
            ref, ...props, color,  fontWeight, whiteSpace, textDecorationLine
        }
        
        return <NBText { ...componentProps }   />
    })
}

export const Text = WithHighlight(textFactory(), ({ _text = {}, props}) => omitBy({ ...props, ..._text}, (value) => value === undefined))

export const Small = WithBaseStyles(Text, {
    defaultProps: {
        fontSize: "sm",
    },
})

export const Strong = WithBaseStyles(Text, {
    defaultProps: {
        fontWeight: "bold",
    },
})